import { Loader2 } from 'lucide-react'

interface LoadingFallbackProps {
  message?: string
  fullScreen?: boolean
}

export default function LoadingFallback({ 
  message = 'Chargement...', 
  fullScreen = false 
}: LoadingFallbackProps) {
  const containerClass = fullScreen 
    ? 'fixed inset-0 bg-white z-50' 
    : 'w-full h-64'
  
  return (
    <div className={`${containerClass} flex items-center justify-center`}>
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-8 h-8 text-yellow-500 animate-spin" />
        <span className="text-sm text-gray-500">{message}</span>
      </div>
    </div>
  )
}
